import { Environment } from 'store/constants';

/**
 * Get current environment name
 *
 * Priority:
 * 1. Hostname-based detection for local development - always returns 'local' for localhost/127.0.0.1/lvh.me
 * 2. CI/CD Environment Variable (REACT_APP_ENV) - explicit environment override
 * 3. URL-based detection - checks origin for environment identifiers
 *
 * @returns The current environment identifier
 */
export const getCurrentEnvironment = (): Environment => {
  const { origin } = window.location;
  const normalizedOrigin = origin.toLowerCase();
  if (
    normalizedOrigin.includes('localhost') ||
    normalizedOrigin.includes('127.0.0.1') ||
    normalizedOrigin.includes('lvh.me')
  ) {
    return 'local';
  }
  const appEnv = process.env.REACT_APP_ENV?.toLowerCase();
  if (appEnv) {
    return appEnv as Environment;
  }
  if (normalizedOrigin.includes('staging')) return 'staging';
  if (normalizedOrigin.includes('qa')) return 'qa';
  if (normalizedOrigin.includes('uat')) return 'uat';
  if (normalizedOrigin.includes('demo')) return 'demo';
  if (normalizedOrigin.includes('auto')) return 'auto';
  if (normalizedOrigin.includes('perf')) return 'perf2';
  if (normalizedOrigin.includes('member.dev')) return 'devint';
  if (normalizedOrigin.includes('dev')) return 'dev';
  if (normalizedOrigin.includes('training')) return 'training';

  return 'production';
};

/**
 * Check if the current environment is production
 * @returns true if in production environment, false otherwise
 */
export const isProduction = (): boolean => {
  const env = getCurrentEnvironment();
  return env === 'production';
};
